export default function NotFoundUseful() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>This page does not exist.</p>

      {/* Developers sometimes hide things here */}
      <span style={{ display: "none" }}>DEBUG</span>
    </div>
  );
}

/*User-agent: *
id 18:  Navigate to -> /playground/Experimental.     */
